/**
 * components/Toast/toastConfig.tsx
 * Maps each tone to the single ToastItem renderer. One renderer, four bindings
 * — the tone is a prop, not four near-identical components.
 */
import type { ToastConfig, ToastConfigParams } from 'react-native-toast-message';
import ToastItem from './ToastItem';
import { TOAST_TYPES, type ToastTone } from './types';

const render = (tone: ToastTone) => (params: ToastConfigParams<unknown>) => (
  <ToastItem tone={tone} title={params.text1} message={params.text2} />
);

export const toastConfig: ToastConfig = TOAST_TYPES.reduce<ToastConfig>((acc, tone) => {
  acc[tone] = render(tone);
  return acc;
}, {});

export default toastConfig;
